import React from 'react';

import { Size } from '../constants';

import { HUGE_ICON_SVGS, HugeIcon } from './HugeIcon.consts';
import { hugeIconStyles } from './HugeIcon.styles';

export type HugeIconSize = Size.MEDIUM | Size.LARGE;

interface HugeIconProps {
  icon: HugeIcon;
  gridBackground?: boolean;
  invert?: boolean;
  size?: HugeIconSize;
}

const HugeIcons: React.FC<HugeIconProps> = ({
  icon,
  size = Size.MEDIUM,
  invert = false,
  gridBackground = true
}) => {
  const IconSVG = HUGE_ICON_SVGS[icon];
  const iconClasses = hugeIconStyles({
    size,
    invert,
    gridBackground
  });

  return (
    <span className={iconClasses}>
      <IconSVG />
    </span>
  );
};

export default HugeIcons;
